import React from 'react'

import { MAX_UPLOAD_MB } from '../../../common/constants'
import { t } from '../../i18n'

export const LogoNotes = () => <span>{`(${t.maxSize.get()} ${MAX_UPLOAD_MB} MB)`}</span>
